/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import React, { useMemo, useEffect, useCallback } from "react";

import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles";

import CssBaseline from "@mui/material/CssBaseline";

import getDesignTokens from '../theme';


import MainContainer from "./MainContainer";

import { useLocalStorage } from "./hooks"

const ColorModeContext = React.createContext({ toggleColorMode: () => { } });

const Layout = (props) => {
    const [colorMode, setColorMode] = useLocalStorage('theme.mode', 'light');
    const contextVal = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setColorMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
            },
        }),
        [setColorMode],
    );
    const theme = useMemo(() => createTheme(getDesignTokens(colorMode)), [colorMode]);

    const catchExternalLink = useCallback(e => {
        if (typeof window !== undefined) {
            const currentUrl = new URL(window.location.href);

            try {
                const targetUrl = new URL(e.currentTarget.getAttribute('href'));

                if (targetUrl.host !== currentUrl.host) {
                    if (window.isIDANativeApp) {
                        const nativeData = { action: 'openExternalUrl', url: e.currentTarget.getAttribute('href') };
                        window.ReactNativeWebView.postMessage(JSON.stringify(nativeData));
                    } else {
                        window.open(targetUrl, '_blank');
                    }
                    e.preventDefault();
                }
            } catch (e) { }
        }
    });

    useEffect(() => {
        if (typeof window !== undefined) {

            document.querySelectorAll('a').forEach(el =>
                el.addEventListener('click', catchExternalLink)
            );
        }
    });

    return (
        <ColorModeContext.Provider value={contextVal}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme} >
                    <CssBaseline />
                    <MainContainer {...props} />

                </ThemeProvider>
            </StyledEngineProvider>
        </ColorModeContext.Provider>
    );
};


export default Layout;

export { ColorModeContext };
